export default {
      id: "bill-usage",
      viewBox: "-2.167 0 24 24",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#bill",
      toString: function () {
        return this.url;
      }
    }